import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const Description = styled.p`
  color: ${p => p.theme.token('text-reversed')};
  width: 100%;
  margin-block-start: 0;
  text-align: center;
  text-shadow: none;
  ${Styles.mobile} {
    padding: 0 ${primitive.$spacing4};
  }
  ${Styles.desktop} {
    max-width: 30rem;
    text-align: start;
  }
`;
